module.exports = __webpack_public_path__ + "img/10_Installation@2x.a55a8ebc.jpg";